import { ComponentType } from 'react';

import { CartWidget, ProductDetailsWidget, ProductExplorer, PurchaseWidget } from '~widgets'; // NOSONAR typescript:S1874 -- ProductExplorer is scheduled for rewrite

export interface WidgetsInterface {
  id: string;
  component: ComponentType;
}

export const PRODUCT_EXPLORER: WidgetsInterface = {
  component: ProductExplorer, // NOSONAR typescript:S1874 -- ProductExplorer is scheduled for rewrite
  id: 'product-explorer',
};

export const PRODUCT_DETAILS: WidgetsInterface = {
  component: ProductDetailsWidget,
  id: 'product-details',
};

export const PURCHASE: WidgetsInterface = {
  component: PurchaseWidget,
  id: 'purchase',
};

export const CART: WidgetsInterface = {
  component: CartWidget,
  id: 'cart',
};
